<div class="content">
  <div class="plate plate-light_blue p-0 m-2" style="max-width:900px;">
    <div class="plate plate-dark_blue swoosh swoosh-cfi-home">
      <div>
        <h1>Activate your device.</h1>
      </div>
    </div>
    <div class="plate-header p-4" *ngIf="!loading">
      <div *ngIf="!foundCode" class="d-flex flex-column align-items-center align-content-center">
        <div class="font-weight-bold mb-2">Enter code below.</div>
        <div class="alert alert-danger" *ngIf="error">{{error.message}}</div>
        <input id="claim-code" [(ngModel)]="code" type="text" class="form-control m-2"
          style="width: 6em; text-align:center;" autocomplete="off" autocorrect="off" autocapitalize="characters"
          spellcheck="false" minlength="4" maxlength="4" />
        <button (click)="findCode(code)" class="btn btn-round btn-primary"
          [disabled]="code.length !== 4">Submit</button>
      </div>
      <div *ngIf="foundCode">
        <div *ngIf="verification && user === null && !showSignup && !showLoginForm"
          class="d-flex flex-column align-items-center align-content-center">
          <div class="font-weight-bolder" class="alert alert-success">
            {{verification.code}}
          </div>
          <div class="p-4">
            You can authenticate your device by logging in or creating a new account.
          </div>
          <div class="d-flex">
            <a class="btn btn-link" href (click)="toggleLoginForm($event)" style="margin: 0px 24px;">Login</a>
            <a class="btn btn-round btn-primary" href (click)="signup($event)">Create a free account</a>
          </div>
        </div>
        <div *ngIf="verification && user !== null && !showSignup && !showLoginForm"
          class="d-flex flex-column align-items-center align-content-center">
          <div class="font-weight-bold" class="alert alert-success">
            {{verification.code}}
          </div>
          <div class="d-flex">
            Success! This code has been claimed.
          </div>
        </div>

        <ng-container *ngIf="user === null && showLoginForm">
          <app-login (onComplete)="onLoginFormComplete()" (onCancel)="onLoginFormCancel()"
            (onShowSignupForm)="onShowSignupForm($event)">
          </app-login>
        </ng-container>
        <div *ngIf="user === null && showSignup">
          <app-signup [showCfiCredentials]="true" [showCancelButton]="true" [course]="course"
            submitButtonLabel="Submit" (onCompleted)="onSignupCompleted($event)" (onCancel)="onSignupCancel($event)">
          </app-signup>
        </div>
      </div>
    </div>
  </div>
</div>